import { useState } from 'react';
import { ConfirmTransactionRequest } from 'vopay';
import { useApi } from '#shared/providers/Api';

// Confirm (un-flag) a flagged transaction for shared/TransactionHistory (ID-13367). Replaces
// client-dashboard's legacy withApiHook tuple usePostConfirmTransaction with a Direct-Pattern hook on the
// host-injected api: throws on Success: false so the caller surfaces the failure through useAlertDialog,
// instead of the old effect-driven shouldConfirm flag + error-alert state.
export default function useConfirmTransaction() {
  const api = useApi();
  const [confirming, setConfirming] = useState(false);

  async function confirmTransaction(req: ConfirmTransactionRequest) {
    try {
      setConfirming(true);
      const res = await api.postConfirmTransaction(req);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setConfirming(false);
    }
  }

  return { confirming, confirmTransaction };
}
